
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class GroupCondizioniVendita extends Vue {
  @Prop() data!: any;
}
